import { useEffect, useState } from "react";
import styled from "styled-components";
import { userContext } from '../../usercontext';
import TestChatBotComp from "../../components/TestChatbotComp";
import GetStartedComp from "../../components/GetStartedComp";
import ContentComp from "../../components/ContentComp";
import InsightsComp from "../../components/InsightsComp";
import Profile from "../../components/Profile";
import Billing from "../../components/Billing";
import LoadingComponent from "../../components/LoadingComponent";
import ShoppingProductsComp from "../../components/ShoppingProducts";
import theme from "../../theme";

interface Props{
  history?: any;
}

const NAV_ITEMS = [
  { id: "start", label: "Get Started" },
  { id: "test", label: "Test Chatbot" },
  { id: "content", label: "Content" },
  { id: "products", label: "Products" },
  { id: "insights", label: "Insights" },
  { id: "profile", label: "Profile" },
  { id: "billing", label: "Billing" },
]

const Dashboard: React.FC<Props> = (props) => {

  const [ user, setUser ] = useState<any>("")
  const [ showitem, setshowitem ] = useState("start")

  const changeshowitem = (id: any)=>{
    setshowitem(id)
  }

  const showComp = () => {
      switch(showitem){
      case "start":
        return <GetStartedComp onNavigate={changeshowitem} />
      case "test":
        return <TestChatBotComp userid={user.userid}/>
      case "content":
        return <ContentComp userid={user.userid} />
      case "products":
        return <ShoppingProductsComp userid={user.userid} />
      case "insights":
        return <InsightsComp userid={user.userid} />
      case "profile":
        return <Profile />
      case "billing":
        return <Billing />
      default:
        return <></>
    }
  }


  useEffect(() => {

  }, [showitem])

  useEffect(() => {
    const subscription = userContext.user.subscribe((x:any) => setUser(x))
    return () => subscription.unsubscribe()
  }, [])

  useEffect(()=>{
    if(!user)return;
    if(user.status!==200){
      props.history.push("/login")
    }
  })

  const activeLabel = NAV_ITEMS.find((item) => item.id === showitem)?.label || "Dashboard"

  return (
    <>
      <PageContainer>
        {user&&user.status==200?<>
          <TopBar>
            <Greeting>Welcome back{user.firstname ? `, ${user.firstname}` : ""}</Greeting>
            <SectionLabel>{activeLabel}</SectionLabel>
          </TopBar>
          <Layout>
            <Sidebar>
              {NAV_ITEMS.map((item) => {
                const active = showitem === item.id
                return (
                  <NavItem key={item.id} $active={active} onClick={()=>changeshowitem(item.id)}>
                    <span>{item.label}</span>
                  </NavItem>
                )
              })}
            </Sidebar>
            <ContentCard>
              {showComp()}
            </ContentCard>
          </Layout>
          </>:
          <LoadingRow>
            <LoadingComponent />
          </LoadingRow>
        }
      </PageContainer>
    </>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 20px 60px;
  @media (max-width: 770px) {
    padding: 16px 12px 40px;
  }
`

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`

const Greeting = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: ${theme.colors.text};
`

const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.textMuted};
`

const Layout = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 220px;
  flex-shrink: 0;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.lg};
  box-shadow: ${theme.shadow.card};
  padding: 10px;
  @media (max-width: 770px) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
`

const NavItem = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: ${theme.radius.md};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  color: ${(p) => (p.$active ? theme.colors.primaryDark : theme.colors.textMuted)};
  background: ${(p) => (p.$active ? theme.colors.primarySoft : "transparent")};
  transition: background 0.15s ease;
  &:hover {
    background: ${theme.colors.primarySoft};
  }
`

const ContentCard = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.lg};
  box-shadow: ${theme.shadow.card};
  padding: 28px;
  color: ${theme.colors.text};
  @media (max-width: 770px) {
    padding: 18px;
  }
`

const LoadingRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 60px 0;
`

export default Dashboard;
